import store from '../store'

// ==========================================================================
//
// SYNC - SECTION
//
// ==========================================================================

/**
 * Diese Funktion durchläuft die JSON-Struktur rekrusiv und stellt alle
 * Dateien und Unterverzeichnisse unter einem bestimmten Pfad in das
 * relustList-Array. 
 *
 * @param  {d} JSON-Struktur
 * @param  {string} path - Pfad innerhalb der JSON-Struktur
 */

export const walkTree = (d, callback) => {
    let type = typeof d

    if (type === 'object') {
        for (let key in d) {
            if (key === 'type') {
                callback(d)
            }

            walkTree(d[key], callback)
        }
    }
}

/**
 * Die Funktion gibt den aktuellen Verzeichnisbaum ab einem bestimmten Pfad
 * als JSON-Struktur zurück. Wird kein Pfad angegeben, so wird der gesamte 
 * Verzeichnisbaum zurückgegeben. 
 *
 * @param  {string} path - Pfad auf das Inhaltsverzeichnis
 * @param  {boolean} dirOnly - Nur Verzeichnisse zurückgeben, keine Dateien
 * @return {json} JSON-Struktur mit dem aktuellen Inhalt
 */
export const getTree = (path = '', dirOnly = false) => {
    const { currentPortfolio } = store.getState().portfolio;

    let resultList = [];

    const walk = (d, path) => {
        let type = typeof d

        if (type === 'object') {
            for (let key in d) {
                if (key === 'type') {
                    if (d.path === path) { resultList.push(d) }
                }
                walk(d[key], path)
            }
        }
    }

    walk(currentPortfolio, path)

    if (dirOnly) {
        const directories = resultList.filter(d => d.type === 'directory')
        resultList = directories
    }

    return resultList;
}

export const getNode = (path) => {
    const productList = getTree(path);

    return productList.length > 0 ? productList[0] : null;
}

// ==========================================================================
//
// CONTAINER - SECTION
//
// ==========================================================================

export const getContainer = (sContainer) => {
    const { containerList } = store.getState().container;

    if (containerList.length === 0) return null;

    const filter = containerList.filter(d => d.id.localeCompare(sContainer) === 0);

    if (filter.length > 0) {
        return filter[0];
    }
    return null;
}

export const getDownload = (sContainer) => {
    const { downloadList } = store.getState().container;

    if (downloadList.length === 0) return null;

    const filter = downloadList.data.filter(d => d.id.localeCompare(sContainer) === 0);

    if (filter.length > 0) {
        return filter[0];
    }
    return null;
}

export const containersInPortfolioList = (allPortfolioList) => {

    //console.log('containersInPortfolioList()', allPortfolioList);

    let containerList = {};
    allPortfolioList.forEach((d) => {
        const splitID_array = d.id.split('_');
        const splitID_container = (splitID_array.length > 0) ? splitID_array[0] : null;
        containerList[splitID_container] = '';
    });

    const downloadedContainers = Object.keys(containerList)

    //console.log('downloadedContainers:', downloadedContainers);

    return downloadedContainers;
}

// ==========================================================================
//
// PORTFOLIO - SECTION
//
// ==========================================================================

export const getPortfolio = (name) => {
    const { portfolioList } = store.getState().portfolio;

    const filter = portfolioList.filter(p => p.name === name);

    if (filter.length > 0) {
        return filter[0];
    }
    return filter;
}

/**
 * Image (png/jpg) innerhalb eines Knotens der JSON-Struktur suchen.
 * Bilder werden pysikalisch in den resources-Verzeichnissen
 * 'portfolios', 'groups' und 'products' abgelegt. 
 * Über den Parameter 'portfolio' wird festgelegt, in welchem 
 * Verzeichnis gesucht werden soll.
 * Der Parameter 'filePostfix' legt fest welche Endung die Datei vor der
 * Datei-Extention haben muss. Erlaubt sind '_main' und '_free'.
 * 
 * @param  {object} node - Knoten in JSON-Struktur
 * @param  {string} portfolio - Portfolio-Verzeichnis
 * @param  {string} filePostfix - Datei-Endung vor Extention
 * @return {Object} { fileName, url }
 */
export const getPortfolioImage = (node, portfolio, filePostfix) => {
    let url = ''
    let fileName = ''

    const files = node.filter((f) => f.name.indexOf('_' + filePostfix) !== -1)
    if (files.length > 0) {
        fileName = files[0].name;
        url = getURL('portfolio', portfolio, fileName);
    }

    return { fileName, url };
}

/**
 * Die Funktion gibt den aktuellen Verzeichnisbaum ab einem bestimmten Pfad
 * als JSON-Struktur zurück. Wird kein Pfad angegeben, so wird der gesamte 
 * Verzeichnisbaum zurückgegeben. 
 *
 * @param  {string} path - Pfad auf das Inhaltsverzeichnis
 * @param  {boolean} dirOnly - Nur Verzeichnisse zurückgeben, keine Dateien
 * @return {json} JSON-Struktur mit dem aktuellen Inhalt
 */
export const getTreePortfolio = (path = '', dirOnly = false) => {
    const { currentPortfolio } = store.getState().portfolio;

    if (currentPortfolio === null) return null;

    const levels = path.split('/')

    const getNode = (d, name) => {
        for (let key in d) {
            const child = d[key]

            if (child.name === name) {
                return child.children;
            }
        }
        return null;
    }

    /*  
    console.log('getTreePortfolio() path:', path)  
    console.log('levels.length:', levels.length)    
    console.log('levels[0]:', levels[0])    
    console.log('levels[1]:', levels[1])    
    console.log('levels[2]:', levels[2])    
    */

    let node = null;
    if (levels.length > 0 && levels[0] !== "") {
        //node = getNode( portfolioList, levels[0])
        node = currentPortfolio.children;
        //console.log('portfolio:', node)    
    }

    if (levels.length > 1 && levels[1] !== "") {
        node = getNode(node, levels[1])
        //console.log('group:', node)    
    }

    if (levels.length > 2 && levels[2] !== "") {
        node = getNode(node, levels[2])
        //console.log('product:', node)    
    }

    if (dirOnly && node) {
        return node.filter(d => d.type === 'directory')
    }
    //console.log('return node:', node)    
    return node;
};

// ==========================================================================
//
// GROUP - SECTION
//
// ==========================================================================

/**
 * getFilesInGroup()
 * 
 * Gibt die Anzahl Dateien in einer Produktgruppe zurück
 * 
 * Eine Produktgruppe kann neben den Unterverzeichnis für
 * jedes Produkt noch weitere Datein wie Bilder oder PDFs
 * enthalten. Die Funktion zählt nun die Dateien einer 
 * Produktgruppe und liefert diesen Wert zurück.
 * 
 * @param  {array} group - Knoten der Produktgruppe
 * @return {integer} - Anzahl Dateien in der Produktgruppe
 *
 */
export const getFilesInGroup = (group) => {
    //console.log('getFilesInGroup() group', group);

    if (!group || !(group['children'])) return 0;

    const grFilter = group.children.filter((f) => f.type === 'file');

    return grFilter.length;
}

/**
 * getProductsInGroup()
 * 
 * Gibt die Anzahl der Produkte einer Produktgruppe zurück
 * 
 * Eine Produktgruppe kann aus mehreren Produkten entstehen.
 * Jedes Produkte einer Produktgrupper wird in einem eigenen
 * Unterverzeichnis gespeichert. Die Funktion zählt nun die
 * Anzahl der Unterverzeichnisse und liefert diesen Wert zurück.
 * 
 * @param  {array} group - Knoten der Produktgruppe
 * @return {integer} - Anzahl der Produkt in der Produktgruppe

 */
export const getProductsInGroup = (group) => {
    //console.log('getProductsInGroup() group', group);

    if (!group || !(group['children'])) return 0;

    const grFilter = group.children.filter((f) => f.type === 'directory');

    return grFilter.length;
}

// funktioniert leider nicht, da group nicht aktualisiert wird.
export const isProductGroupImage = (product, group) => {
    let grImageProduct = null;
    grImageProduct = getGroupImageJSON(group);

    if (grImageProduct === null) return false;

    const isGroupImage = (grImageProduct.localeCompare(product) === 0);

    //console.log('grImage:', grImageProduct);
    //console.log('isGroupImage:', isGroupImage);

    return isGroupImage;
}

/**
 * Gibt den Inhalt der Datei: 'sequence.json' zurück
 */
export const getSequence = (path) => {

    const node = getTree(path);

    const filter = node.filter(f => f.name === 'sequence.json');

    return filter.length > 0 ? filter[0].sequence : null;
}


/**
 * Prüfung, ob ein Parameter eine Funktion ist
 */
export const isFunction = (param) => {
    return param && (Object.prototype.toString.call(param) === "[object Function]" || typeof param === "function" || param instanceof Function);
}



/**
 * getGroupImageJSON()
 * 
 * Hier wird das Gruppenbild einer Produktgruppe ermittelt.
 * 
 * Falls in der Produktgruppe 'group' die Datei 'groupimage.json'
 * existiert, dann liefert dieses Produkt den Freisteller, der als
 * Gruppenbild angezeigt wird.
 * 
 * Ansonsten wird der Freisteller aus dem ersten Produkt der Produktgruppe
 * entnommen. Falls die Reihenfolge der Produkte mittels 'sequence.json' 
 * geändert wurde, so wird diese NICHT berücksichtigt.
 * 
 * @param  {array} group - Knoten der Produktgruppe
 * @return {object} - Produkt, welches das Gruppenbild enthält
 */
export const getGroupImageJSON = (group) => {
    const debug = false;

    // wenn die Gruppe keine Kinder hat, so kann auch kein Freisteller ermittelt werden!
    if (getFilesInGroup(group) === 0) {
        debug && console.log('Gruppe hat keine Dateien!')
        return null;
    }

    const grFilter = group.children.filter((f) => f.name === 'groupimage.json');
    if (grFilter.length > 0) {
        const grImage = grFilter[0];
        if (grImage.groupimage.length > 0) {
            debug && console.log("Datei 'groupimage.json' existiert. Produkt:", grImage.groupimage[0]);

            if (grImage.groupimage.length > 0) {
                return grImage.groupimage[0];
            }
        }
    }
    return null;
}

/**
 * getGroupImage()
 * 
 * Hier wird das Gruppenbild einer Produktgruppe ermittelt.
 * 
 * Falls in der Produktgruppe 'group' die Datei 'groupimage.json'
 * existiert, dann liefert dieses Produkt den Freisteller, der als
 * Gruppenbild angezeigt wird.
 * 
 * Ansonsten wird der Freisteller aus dem ersten Produkt der Produktgruppe
 * entnommen. Falls die Reihenfolge der Produkte mittels 'sequence.json' 
 * geändert wurde, so wird diese NICHT berücksichtigt.
 * 
 * @param  {array} group - Knoten der Produktgruppe
 * @return {object} - Produkt, welches das Gruppenbild enthält
 */
export const getGroupImage = (group) => {
    const debug = false;

    debug && console.log(`getGroupImage() group:`, group);

    // wenn die Gruppe keine Kinder hat, so kann auch kein Freisteller ermittelt werden!
    if (getProductsInGroup(group) === 0) {
        debug && console.log('Gruppe hat keine Produkte!')
        return null;
    }

    // Freisteller in allen Dateien eines Produktes suchen
    const getGroupProduct = (product) => {
        const files = product.children.filter((f) => f.name.indexOf('_free') !== -1)
        if (files.length > 0) {
            let file = files[0];
            debug && console.log('      Freisteller gefunden: ', file);
            return { groupName: group.name, productName: product.name, fileName: file.name, node: file };
        }
        return null;
    }

    const grProductName = getGroupImageJSON(group);

    // Schleife über alle Produkte der Gruppe
    for (let product of group.children) {
        debug && console.log("   Produkt: ", product);

        if (!product['children']) {
            debug && console.log('Produkt hat keine Kinder!');
            continue;
        }

        if (product.children.length === 0) {
            debug && console.log('Produkt hat Kinder, aber keine weiteren Dokumente!')
            continue;
        }

        if (grProductName) {
            if (grProductName && product.name === grProductName) {
                debug && console.log("\n\n---> FREISTELLER anhand DATEI: 'groupimage.json' ermittelt\n\n");
                return getGroupProduct(product);
            }
        } else {
            debug && console.log('\n\n---> Freisteller aus erstem Produkt der Gruppe entnommen\n\n');
            return getGroupProduct(product)
        }
    }
    debug && console.log('kein Freisteller gefunden!')
    return null;
}

// ==========================================================================
//
// PRODUCT - SECTION
//
// ==========================================================================

/**
 * Die Funktion gibt den aktuellen Verzeichnisbaum ab einem bestimmten Pfad
 * als JSON-Struktur zurück. Wird kein Pfad angegeben, so wird der gesamte 
 * Verzeichnisbaum zurückgegeben. 
 *
 * @param  {string} path - Pfad auf das Inhaltsverzeichnis
 * @param  {boolean} dirOnly - Nur Verzeichnisse zurückgeben, keine Dateien
 * @return {json} JSON-Struktur mit dem aktuellen Inhalt
 */
export const makeProductList = (portfolioList) => {

    let productList = [];
    const walkProduct = (d) => {
        const type = typeof d

        if (type === 'object') {
            for (let key in d) {
                if (key === 'type') {
                    if (d.type === 'directory') {
                        if (checkSubDir(d) === false) {
                            const meta = d.children.filter(p => p.name === 'meta.json')
                            if (meta.length > 0) {
                                d['meta'] = meta[0].meta;
                            }
                            const filter = d.children.filter(p => p.name === 'images.json')
                            if (filter.length > 0) {
                                d['images'] = filter[0].images;
                            }
                            productList.push(d);
                        }
                    }
                }
                walkProduct(d[key])
            }
        }
    }

    walkProduct(portfolioList)

    return productList;
}

export const makeTagList = (productList) => {

    let tagThemeList = [];
    let tagProductList = [];
    let tagImageList = [];

    for (let i = 0; i < productList.length; i++) {
        const product = productList[i];

        if (product['meta']) {
            const meta = product.meta;

            if (meta['tags']) {
                if (meta['tags']['theme']) {
                    for (let j = 0; j < meta['tags']['theme'].length; j++) {
                        const tag = meta['tags']['theme'][j];
                        if (tag === '') continue;
                        if (tagThemeList.indexOf(tag) === -1) {
                            tagThemeList.push(tag);
                        }
                    }
                }
                if (meta['tags']['product']) {
                    for (let j = 0; j < meta['tags']['product'].length; j++) {
                        const tag = meta['tags']['product'][j];
                        if (tag === '') continue;
                        if (tagProductList.indexOf(tag) === -1) {
                            tagProductList.push(tag);
                        }
                    }
                }
            }
        }
        if (product['images']) {
            const images = product.images;

            for (let i = 0; i < images.length; i++) {
                const image = images[i];
                if (image['tags']) {
                    for (let j = 0; j < image['tags'].length; j++) {
                        const tag = image['tags'][j];
                        if (tag === '') continue;
                        if (tagImageList.indexOf(tag) === -1) {
                            tagImageList.push(tag);
                        }
                    }

                }
            }
        }
    }
    //console.log('tagImageList:', tagImageList)
    //console.log('tagThemeList:', tagThemeList )
    //console.log('tagProductList:', tagProductList )

    return { theme: tagThemeList, product: tagProductList, image: tagImageList };
}

export const getProductImage = (node, path, filePostfix) => {
    let url = ''
    let fileName = ''
    let filePath = ''

    const files = node.filter((f) => f.name.indexOf('_' + filePostfix) !== -1)

    if (files.length > 0) {
        fileName = files[0].name;
        filePath = files[0].path;
        url = getURL('product', path, fileName);
    }

    return { fileName, filePath, url };
}

/**
 * Liste mit allen Dateien eines bestimmten Datei-Typs erstellen
 *
 * Die Funktion durchläuft die portfolioList und erstellt eine Liste 
 * mit allen Dateien eines bestimmten Datei-Typs und gibt diese List nach 
 * dateigröße sortiert zurück. 
 * Über den Schalter 'bDuplicates' werden Duplikate eliminiert.
 * 
 * @param  {json} portfolioList - JSON-Struktur mit den aktuellen Portfolios
 * @param  {string} fileExt - Datei-Typ ('png', 'pdf', 'mp4', etc.)
 * @return {json} JSON-Struktur - fileList (sorted) 
 * 
 */
export const getFileList = (container, portfolioList, fileExt) => {

    const maxFileSize = parseInt(process.env.REACT_APP_MAX_FILE_SIZE);

    let arrListTmp = [];
    const _walk = (d) => {

        if (d.type === 'file') {
            const ext = getFileExtension(d.name)

            if (ext === fileExt) {

                if (d.size >= (maxFileSize * 1024 * 1024)) {
                    console.log(`FEHLER: Datei [${d.name}] ist mit ${parseInt(d.size / 1024)} MB zu groß! maximal erlaubt sind ${maxFileSize} MB.`);
                } else {
                    const sID = `${container}/${d.path}/${d.name}`;
                    arrListTmp.push({ id: sID, path: d.path, name: d.name, size: d.size });
                }
            }
        }
    }

    walkTree(portfolioList, _walk);

    let documentList = arrListTmp.sort(dynamicSortNumber('size'));

    if (fileExt === 'mp4') {

        // duplicate entfernen
        const arrListSort = [];

        let lastName = '';
        for (let d of documentList) {
            if (d.name === lastName) continue;

            lastName = d.name;
            arrListSort.push(d);
        }
        //console.log('arrListSort:', arrListSort)
        return arrListSort;
    }

    return documentList;
}

// ==========================================================================
//
// LAYOUT - SECTION
//
// ==========================================================================

export const getCustomLayoutTile = (d) => {
    const { customLayout } = store.getState().app;

    const filter = customLayout.filter(t => t.i === d.name);

    return filter.length > 0 ? filter[0] : null;
}

export const checkLayoutChanged = (oldLayout, newLayout) => {

    console.log('oldLayout:', oldLayout.length)
    console.log('newLayout:', newLayout.length)
    console.log('return:', newLayout.length > oldLayout.length)

    return newLayout.length + 1 > oldLayout.length;
}

// ==========================================================================
//
// NAVIGATION - SECTION
//
// ==========================================================================

export const getDialogByPath = (path) => {

    const pathList = path.split('/');

    let dialogType = "";
    let portfolio = "";
    let groups = "";
    let product = "";

    if (pathList.length <= 1 && path === "") {
        dialogType = "portfolio"
    } else {
        if (pathList.length >= 1) {
            dialogType = "groups"
            portfolio = pathList[0];
        }

        if (pathList.length >= 2) {
            groups = pathList[1];
            dialogType = "groups";
        }

        if (pathList.length >= 3) {
            dialogType = "products";
            product = pathList[2];
        }
    }

    return { dialogType: dialogType, portfolio: portfolio, groups: groups, product: product };
}

// ==========================================================================
//
// NODE - SECTION
//
// ==========================================================================

export const checkSubDir = (d) => {
    for (let i = 0; i < d.children.length; i++) {
        if (d.children[i].type === 'directory') return true;
    }
    return false;
}

export const getURL = (type, path, name) => {
    const { apiURL, currentContainer } = store.getState().app;

    return encodeURI(apiURL + `/api/v1/file/${currentContainer}/${type}/${path}/${name}`);
}

/**
 * Liefert eine Liste mit aller Dateien unterhalb eines Knotens
 * die eine bestimmte Endung 'pdf' oder 'mp4' besitzen.
 * 
 * @param  {object} node - Knoten in JSON-Struktur
 * @return {Array} Liste aller Dateien
 */
export const getNodeFiles = (node, ext) => {

    return node.filter(f => [ext].includes(getFileExtension(f.name)))
}

/**
 * getFileInNode()
 * 
 * Bilder, die einem Produkt zugeordnet wurden, haben entweder die Endung
 * (Postfix) '_main' oder '_free'. Die Funktion liefert zu einem bestimmten
 * Postfix die entsprechende Datei.
 * 
 * @param  {array} node - Knoten in JSON-Struktur
 * @param  {string} postfix - ('_main' oder '_free')
 * @return {object} - Object mit Datei-Informationen
 */
export const getFileInNode = (node, postfix) => {
    //console.log(`getFileInNode(${postfix}) node:`, node);

    const files = node.filter((f) => f.name.indexOf('_' + postfix) !== -1)
    if (files.length > 0) {
        return files[0];
    }

    //console.log(`WARNING: File ${postfix} not found in node:`, node);
    return null;
}

/**
 * Liefert eine Liste mit aller Dateien unterhalb eines Knotens
 * Es werden hier aber die Dateien/Bilder herausgefilter, die in
 * der Bilder-Galerie angezeigt werden. 
 * 
 * @param  {object} node - Knoten in JSON-Struktur
 * @return {Array} Liste aller Dateien
 */
export const getGalleryImages = (node) => {

    const imageList = node.filter(f => ['png', 'jpg'].includes(getFileExtension(f.name)))
    const galleryList = imageList.filter((f) => f.name.indexOf('_free') === -1 && f.name.indexOf('_main') === -1);

    if (false) {
        console.log('imageList:', imageList)
        console.log('galleryList:', galleryList)
    }

    return galleryList;
}

export const getProductURL = (node) => {
    const metaFilter = node.filter(d => d.name === 'meta.json')
    if (metaFilter.length > 0) {
        if (metaFilter[0].meta?.url?.length === 0) {
            return null;
        }
        return metaFilter[0].meta.url;
    }
    return null;
}

/**
 * getBase64()
 * 
 * Bilder, die einem Produkt zugeordnet wurden, haben entweder die Endung
 * (Postfix) '_main' oder '_free'. Die Funktion liefert zu einem bestimmten
 * Produkt und Postfix das entsprechende Image im base64-Format.
 * 
 * @param  {object} node - Knoten in JSON-Struktur
 * @return {string} - Object mit PDF-Informationen
 */
export const getBase64 = (node, postfix) => {
    const files = node.filter((f) => f.name.indexOf('_' + postfix) !== -1)
    if (files.length > 0) {
        return files[0].base64;
    }
    //console.log(`WARNING: Image ${postfix} not found in path:`, node.name);

    return "";
}

/**
 * getListViewPDF()
 * 
 * Im Dialog SearchController und Favorites werden alle Suchergebnisse
 * bzw. alle Favoriten in einer Liste angezeigt. Auch wenn zu einem 
 * Produkt mehrere PDF-Dokumente existieren, so wird in diesen Listen
 * immer nur ein eiziges PDF-Dokument angezeigt.
 * 
 * Diese Funktion liefert speziell für diese Listansicht (ListView) 
 * das entsprechende PDF-Dokument.
 * 
 * In der ListView sollte auch keine Preisliste angezeigt werden.
 * 
 * @param  {object} node - Knoten in JSON-Struktur
 * @return {object} - Object mit PDF-Informationen
 */
export const getListViewPDF = (node) => {

    const pdfFileList = node.children.filter((f) => f.name.endsWith('pdf') && !checkPriceListPDF(f.name))

    if (pdfFileList.length > 0) {
        const pdf = pdfFileList[0];
        return { name: pdf.name, path: pdf.path, size: pdf.size, base64: pdf.base64 };
    } else {
        //console.log('WARNING: PDF-Document not found!')
    }

    return { name: '', path: '', size: 0, base64: '' };
}

// ==========================================================================
//
// FAVORED - SECTION
//
// ==========================================================================

export const checkFavored = (path) => {
    const { favoredList } = store.getState().app;

    const filter = favoredList.filter(value => value === path)
    if (filter.length > 0) {
        return true;
    }
    return false;
}

export const getFavourList = () => {
    const { favoredList, productList } = store.getState().app;

    let favourProductList = [];
    for (let i = 0; i < favoredList.length; i++) {
        let path = favoredList[i]
        let productFiltered = productList.filter(d => d.path === path)
        if (productFiltered.length > 0) {
            favourProductList.push(productFiltered[0])
        }
    }
    return favourProductList;
}

// ==========================================================================
//
// FILTER - SECTION
//
// ==========================================================================

export const checkFilter = (filter) => {
    const { filterList } = store.getState().app;

    const filterResult = filterList.filter(value => value === filter)
    if (filterResult.length > 0) {
        return true;
    }
    return false;
}

// ==========================================================================
//
// ICON - SECTION
//
// ==========================================================================

export const getIcon = (id) => {
    const { iconList } = store.getState().icon;

    const filteredIcons = iconList.filter(d => d.id === id)
    if (filteredIcons.length > 0) {
        return filteredIcons[0];
    }
    return null;
}

// ==========================================================================
//
// SORT - SECTION
//
// ==========================================================================

/**
 * Function to sort alphabetically an array of objects by some specific key.
 *
 * @param {String} property Key of the object to sort.
 */
export const dynamicSortString = (property) => {
    let sortOrder = 1;

    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    return function (a, b) {
        if (sortOrder === -1) {
            return b[property].localeCompare(a[property]);
        } else {
            return a[property].localeCompare(b[property]);
        }
    }
}

/**
 * Function to sort alphabetically an array of objects by some specific key.
 *
 * @param {String} property Key of the object to sort.
 */
export const dynamicSortNumber = (property) => {
    let sortOrder = 1;

    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a, b) {
        if (sortOrder === -1) {
            return b[property] - a[property];
        } else {
            return a[property] - b[property];
        }
    }
}

// ==========================================================================
//
// CSS - SECTION
//
// ==========================================================================

export const getStyleHeight = (baseHeight, height, line, font) => {
    return {
        height: parseInt(baseHeight * height) + 'px',
        minHeight: parseInt(baseHeight * height) + 'px',
        lineHeight: parseInt(baseHeight * line) + 'px',
        fontSize: parseInt(baseHeight * font) + 'px'
    }
}

export const getStyleImage = (image) => {
    return {
        backgroundImage: "url(" + image + ")",
        backgroundColor: 'transparent',
        backgroundPosition: 'left top',
        backgroundSize: '100% 100%'
    }
}
export const getStyleBackgroundImageBase64 = (base64, height = '100%', size = 'cover') => {

    if (base64 === null || base64 === undefined) return null;

    return {
        height: height,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: size,
        backgroundImage: `url(${base64})`,
    }
}

export const getStyleBackgroundImage = (image, height = '100%', size = 'cover') => {

    if (image === '') return null;
    if (image === null) return null;
    if (image === undefined) return null;

    let url = image;

    if (window['cordova'] === undefined) {
        try {
            url = window.URL.createObjectURL(image);
        } catch (error) {
            console.log('ERROR: getStyleBackgroundImage():', image)
            console.error(`Error reading Image`, error);
        }
    }

    return {
        height: height,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: size,
        backgroundImage: `url(${url})`,
    }
}

export const getStyleBackgroundURL = (url, height = '100%', size = 'cover') => {

    if (url === null || url === undefined) return null;

    const url2 = url.replace(/\(/g, '%28').replace(/\)/g, '%29');

    return {
        height: height,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: size,
        backgroundImage: `url(${url2})`,
    }
}

export const getPadding = (...args) => {
    let base = 0;
    let top = 0;
    let right = 0;
    let bottom = 0;
    let left = 0;

    if (args.length < 2 || args.length === 4 || args.length > 5) {
        console.log('getPadding(): wrong number of arguments!')
        for (var i = 0; i < args.length; i++) {
            console.log('   argument[' + i + '] = ', args[i]);
        }
        console.log('usage: getPadding( base, top, right, bottom, left )')
    }

    if (args.length > 0) { base = args[0] }

    if (args.length === 2) { top = right = bottom = left = args[1] }

    if (args.length === 3) { right = left = args[1]; top = bottom = args[2] }

    if (args.length === 5) { top = args[1]; right = args[2]; bottom = args[3]; left = args[4] }

    return {
        padding: parseInt(base * top) + 'px ' + parseInt(base * right) + 'px ' + parseInt(base * bottom) + 'px ' + parseInt(base * left) + 'px '
    }
}

// ==========================================================================
//
// OTHER BASICS - SECTION
//
// ==========================================================================

/**
 * zerlegt einen Dateiname in Name und Dateityp 
 * 
 * @param  {string} 03_testpreisliste.pdf
 * @return {json} name, ext, full
 */
export const getFileDetails = (name) => {
    const fileExt = name.split('.').pop();
    const fileName = name.replace(`.${fileExt}`, '');

    //console.log(`getFileDetails(${name}) ext:${fileExt}`, fileName);

    return { name: fileName, ext: fileExt, full: name }
}

/**
 * Prüfung, ob ein Dateiname eine Preisliste enthält
 * 
 * @param  {string} 03_testpreisliste.pdf
 * @return {boolean} true/false
 */
export const checkPriceListPDF = (name) => {
    if (!name) return false;

    return name.toLowerCase().includes("preisliste.pdf");
}

/**
 * Gibt den Dateityp/Dateierweiterung zurück
 * 
 * @param  {string} 03_testpreisliste.pdf
 * @return {string} 'pdf' oder 'mp4'
 */
export const getFileExtension = (name) => {
    return name.split('.').pop();
}

/**
 * Entfernt die Numerierung "03_" im Dateinamen
 * und gibt den reinen Dateinamen zurück
 * 
 * @param  {string} 03_interaktive Distanzweste.pdf
 * @return {string} interaktive Distanzweste.pdf
 */
export const getFileName = (name) => {
    return name.charAt(2) !== '_' ? name : name.substr(3)
}

/**
 * Entfernt die Numerierung "03_" im Dateinamen und die
 * Dateigröße aus dem Namen der Video-Datei
 * 
 * @param  {string} 02_Kombilenkachse_6577311
 * @return {string} Kombilenkachse
 */
export const getCommonFileName = (inputName) => {

    const parts = inputName.split('_');
    const ext = getFileExtension(inputName);

    let helpArr = [];
    for (let i = 1; i < parts.length; i++) {
        helpArr.push(parts[i]);
    }

    const outputName = getFileName(helpArr.join(' '));

    return getFileName(outputName.replace('.' + ext, ''));
}

/**
 * Entfernt die Numerierung "03_" im Dateinamen und die
 * Dateigröße aus dem Namen der Video-Datei
 * 
 * @param  {string} 6577311_Kombilenkachse_Test.mp4
 * @return {string} Kombilenkachse
 */
export const getCommonFileDetails = (inputName) => {
    const debug = false;

    const parts = inputName.split('_');
    debug && console.log(`getCommonFileDetails(${inputName}) length:${parts.length} parts:`, parts);

    if (parts.length >= 2) {
        return { name: parts[1], size: parseInt(parts[0]), ext: getFileExtension(inputName) }
    }
    return { name: inputName, size: 0, ext: getFileExtension(inputName) }
}

export const humanFileSize = (bytes, si = true, dp = 3) => {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }

    const units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10 ** dp;

    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

    return bytes.toFixed(dp) + ' ' + units[u];
}

/**
 * Die Funktion zeigt den aktuellen Zustand des Heap-Speichers.
 * Damit kann überprüft werden, ob in der Anwendung ein Speicher-Leak
 * existiert. #Leak
 * Leider steht die globale Variable nicht in allen Browsern zur Verfügung
 * Gestest habe ich unter Chrome.
 *
 * @return {integer} count - Numerierung der Calls im Log
 */
export const logHeap = (text = '') => {
    const { debugHeap } = store.getState().app;

    if (!debugHeap) return;

    if (performance['memory']) {
        const mem = performance.memory;

        const limit = humanFileSize(mem.jsHeapSizeLimit);
        const total = humanFileSize(mem.totalJSHeapSize);
        const used = humanFileSize(mem.usedJSHeapSize);

        console.log(`HEAP [used: ${used}, limit: ${limit}, total: ${total}] ${text}\n`)
    }
}

/**
 * Diese Funktion ermittelt die nächste freie Zelle
 * innerhalb eines Grids.
 *
 * @return {integer} x = x-Koordinate der freien Zelle
 * @return {integer} y = y-Koordinate der freien Zelle
 */
export const getFreeCellInGrid = (portfolioList) => {
    let begRow = 0;
    let endRow = 0;
    let begCol = 0;
    let endCol = 0;

    let grid = { rows: 4, cols: 6 }

    // initialize matrix with size of grid
    let matrix = Array(grid.rows).fill(0);
    for (let row = 0; row < matrix.length; row++) {
        matrix[row] = Array(grid.cols).fill(0);
    }
    // deep copy of all existing tiles in the grid
    //let tiles = JSON.parse(JSON.stringify(grid.tiles));

    // fill matrix cells by existing tiles
    for (let i = 0; i < portfolioList.length; i++) {
        begRow = portfolioList[i].row;
        endRow = portfolioList[i].row + portfolioList[i].rowSpan;

        for (let row = begRow; row < endRow; row++) {
            begCol = portfolioList[i].col;
            endCol = portfolioList[i].col + portfolioList[i].colSpan;

            for (let col = begCol; col < endCol; col++) {
                matrix[row][col] = 1;
            }
        }
    }

    // find next free cell in matrix
    for (let row = 0; row < matrix.length; row++) {
        for (let col = 0; col < matrix[row].length; col++) {
            if (matrix[row][col] === 0) return { x: col, y: row };
        }
    }

    // return default
    return { x: -1, y: -1 }
}

export const toSqlDatetime = (inputDate) => {
    const date = new Date(inputDate)
    const dateWithOffest = new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
    return dateWithOffest
        .toISOString()
        .slice(0, 19)
        .replace('T', ' ')
}

export const getDateTime = (dateIn) => {
    let yyyy = dateIn.getFullYear();

    let month = dateIn.getMonth() + 1; // getMonth() is zero-based

    let mm = month.toString().padStart(2, "0");
    let dd = dateIn.getDate().toString().padStart(2, "0");
    let HH = dateIn.getHours().toString().padStart(2, "0");
    let MM = dateIn.getMinutes().toString().padStart(2, "0");
    let SS = dateIn.getSeconds().toString().padStart(2, "0");

    return yyyy + mm + dd + HH + MM + SS;
}

export const wait = (ms) => {
    console.log('wait:', ms)
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
}

// fastest and simple string hash function (10^9 hashes => zero collision)
// https://gist.github.com/feeedback/e6d137d3f54b1aa0310d690daadfaf28
// keys 20 length => 1050 hash/ms
// keys 50 length => 750 hash/ms
// keys 500 length => 80 hash/ms
export const cyrb53 = (key, seed = 0) => {
    const A = 2654435761;
    const B = 1597334677;
    const C = 2246822507;
    const D = 3266489909;
    const E = 4294967296;
    const F = 2097151;

    let h1 = 0xdeadbeef ^ seed;
    let h2 = 0x41c6ce57 ^ seed;

    for (let index = 0, char; index < key.length; index++) {
        char = key.charCodeAt(index);

        h1 = Math.imul(h1 ^ char, A);
        h2 = Math.imul(h2 ^ char, B);
    }

    h1 = Math.imul(h1 ^ (h1 >>> 16), C) ^ Math.imul(h2 ^ (h2 >>> 13), D);
    h2 = Math.imul(h2 ^ (h2 >>> 16), C) ^ Math.imul(h1 ^ (h1 >>> 13), D);

    return E * (F & h2) + (h1 >>> 0);
};

export const capitalize = s => (s && s[0].toUpperCase() + s.slice(1)) || "";

/**
 * Analog zu Array.prototype.includes()
 * Diese Methode prüft, ob ein String-Array ('sArray') ein bestimmtes String-Element ('sSearch') enthält, und gibt entsprechend true oder false aus. 
 * Bein Stringvergleich wird die localeCompare() verwendet, damit auch Umlaute korrekt vergleichen werden.
 * 
 * @param  {array} sArray - String-Liste ('schöler', 'lindig', 'linde')
 * @return {string} sSearchString - gesuchte Zeichenkette
 */
export const localeIncludes = (sArray, sSearch) => {
    for (let i = 0; i < sArray.length; i++) {
        if (sSearch.localeCompare(sArray[i]) === 0) return true;
    }
    return false;
}

/**
 * Virtueller Host aus login E-Mail-Adresse ermitteln
 *  
 * @param  {string} email - E-Mail-Adresse 'max.mustermann@muster.com'
 * @return {string} vhost - 'muster'
 */
export const getVirtualHostFromEMail = (email) => {

    if (!email || email === '') return null;

    const domainname = email.substring(email.lastIndexOf("@") + 1);

    const split = domainname.split('.');

    const vhost = split.length > 0 ? split[0] : null;

    return vhost;
}



/**
 * getImage()
 * 
 * die Funktion sucht ein bestimmtes Bild im Bildspeicher 'imageBuffer'
 * 
 * @param  {string} path - pfad
 * @param  {string} name - name
 * @return {object} - Image 
 */
export const getImage = (path, name) => {
    const { currentContainer, imageBuffer } = store.getState().app;

    let sID = `${currentContainer}/${path}/${name}`;

    if (imageBuffer[currentContainer] === undefined) {
        //console.log(`WARNING: ImageContainer [${currentContainer}] not found!`);
        return null;
    }

    const images = imageBuffer[currentContainer].filter(f => f.id.localeCompare(sID) === 0)
    if (images.length > 0) {
        return images[0].data;
    }

    //console.log(`WARNING: Image ${path}/${name} not found!`);
    return null;
}

